import axios  from "axios"
import { loginreq,req } from "./axiosFun"


//const rsurla = 'http://192.168.110.6:8989';
//const rsurla="http://182.92.103.37:8986"
//const rsurla ="http://gansu.xlcpstu.bi-soft.cn/api"
const ml='/api';
//const ml = rsurla;
// 获取当前时间
export const getDateTime = () => {
  const currentTime = new Date();
  const year = currentTime.getFullYear();
  const month = currentTime.getMonth() + 1;
  const day = currentTime.getDate();
  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const seconds = currentTime.getSeconds();
  return year+'-'+month+'-'+day+' '+hours+':'+minutes+':'+seconds;
}

/* export const login = (params) => { return loginreq("post", rsurla+"/login", params) };
 */
// 角色管理
export const roleList = (params) => { return req('get','/api/system/roleList',params)}
export const addRole = (params) => { return req('post','/api/system/addRole',params)}
export const delRole = (params) => { return req('get','/api/system/delRole',params)}
export const roleUsers = (params) => { return req('get','/api/system/roleUsers',params)}
export const setGroups = (params) => { return req('post','/api/system/setGroups',params)}

// 菜单
export const menuList = (params) => { return req('get','/api/system/menuList',params)}
export const authList = (params) => { return req('get','/api/system/authList',params)}

// 权限管理
export const saveAuth = (params) => { return req('post','/api/system/saveAuth',params)}

// 系统设置
export const sysParam = (params) => { return req('get','/api/system/sysParam',params)}
export const wxStart = (params) => { return req('post','/api/system/wxStart',params)}
export const optionList = (params) => { return req('get','/api/system/optionList',params)}
export const setOption = (params) => { return req('post','/api/system/setOption',params)}
export const editRefundPsw = (params) => { return req('post','/api/system/editRefundPsw',params)}
export const captcha = (params) => { return loginreq("get", "/api/login/captcha", params) };


//退出登录
export const login = (params) => { return loginreq("post", ml+'/loginStu', params) };
export const loginout = (params) => { return req("get", ml+'/logout', params) };
//修改密码
export const editpasswd = (params) => { return req("post",ml+'/system/user/profile/studentUpdatePwd', params) };

 export const userList = (params) => { return req('post',ml+'/getInfo',params)}
//获取问题  getdati
export const getdati = (params) => { return req('get',ml+'/Ladata/getdati',params)}


//获取用户信息
export const getuserinfo = (params) => { return req('post',ml+'/userExtra/userExtraInfo/studentInfo',params)}

//获取首页信息
export const getrw = (params) => { return req('get',ml+'/exm/student/studentList',params)}
//获取量表列表  getrwdetail
export const getrwdetail = (params) => { return req('get',ml+'/exm/student/gaugeList',params)}
//获取量表说明 cpjs
 export const getrwsm = (params) => { return req('get',ml+'/gaugeExplain',params)}
//获取问题
export const getques = (params) => { return req('get',ml+'/exm/student/detailedList',params)}
// 获取新的问题类型
export const getquesa = (params) => { return req('get',ml+'/exm/choice/detailedList',params)}
//提交答题 /exm/answer/bathAdd
export const tjdt = (params) => { return req('post',ml+'/exm/answer/bathAdd',params)}
//查看测评结果
export const ckcpjg = (params) => { return req('get',ml+'/exm/student/seeEvaluating',params)}
//查看测评列表s
export const cplist = (params) => { return req('get',ml+'/exm/student/myEvaluation',params)}
//测评任务
export const cprwdata = (params) => { return req('get',ml+'/exm/student/assessmentTask',params)}

//我的咨询 /exm/student/list
export const wdzx = (params) => { return req('get',ml+'/exm/student/list',params)}
//添加咨询内容
export const addzx = (params) => { return req('post',ml+'/exm/student',params)}
//获取字典
export const zidian = (params) => { return req('get',ml+'/system/dict/data/type/exm_gauge_type',params)}
//初始密码提示
export const mmts = (params) => { return req('post',ml+'/defaultPwd',params)}
//删除咨询
export const delzx = (params) => { return req('post',ml+'/exm/student/studentDelete/'+params.id,params)}
//获取回复内容
export const zxdetail = (params) => { return req('get',ml+'/exm/student/studentSeeRply/',params)}
//新增量表接口

// 量表类型
export const lbdetailedList1 = (data) => {return req('get',ml+'/exm/choice/detailedList',data)}

export const lbdetailedList = (data) => {return req('get',ml+'/exm/student/detailedList',data)}
// 答题1
export const dati = (data) => {return req('post',ml+'/exm/answer/bathAdd',data)}
export const dati1 = (data) => {return req('post',ml+'/exm/AnswerChoice/batchAdd',data)}
// 查看评测结果1
export const ckpcjg1 = (data) => {return req('get',ml+'/exm/AnswerChoice/apiDiscResult',data)}
// 查看评测结果2
export const ckpcjg2 = (data) => {return req('get',ml+'/exm/student/firoEvaluting',data)}



// WEBPACK FOOTER //
// ./src/api/baseset.js